<template>
    <div>
        <table class="table">
            <tr v-for="connection in connected" :key="connection.id">
                <td class="align-middle">
                    <img class="source-logo" :src="'/assets/img/reviews/' + connection.source + '.png'"/>
                </td>
                <td class="align-middle">
                    <click-hint-connection-name :connection="connection"/>
                </td>
                <td class="align-middle">
                    <div class="d-flex align-items-center">
                        <i class="fas fa-check-circle gradient-success f2 mr-2"></i> <strong>Connected</strong>
                    </div>
                </td>
                <td>
                    <button class="btn btn-default btn-rounded" @click="removeConnection(connection)"><i class="fa fa-times"></i></button>
                </td>
            </tr>
            <tr>
                <td colspan="3">
                    <div class="d-flex align-items-end justify-content-end" v-if="connected !== null">
                        <strong>Create new connection</strong>
                        <div class="d-flex col justify-content-end">
                            <div class="mr-3">
                                <label class="light-text text-uppercase">Choose Channel</label>
                                <select class="form-control" v-model="selectedChannel">
                                    <option v-for="channel in availableChannels" :key="channel" :value="channel">{{ sourceLabelFromSlug(channel) }}</option>
                                </select>
                            </div>
                            <div class="mr-3">
                                <label class="light-text text-uppercase mr-2">Enter Name:</label>
                                <i class="fas fa-info info-circle align-middle" data-toggle="tooltip" data-placement="top" :title="`Enter the name exactly as it appears in your ${sourceLabelFromSlug(selectedChannel)} extranet.`"></i>
                                <input class="form-control" type="text" v-model="newChannelSlug" />
                            </div>
                            <div>
                                <label class="light-text text-uppercase mr-2">Enter URL:</label>
                                <i class="fas fa-info info-circle align-middle" data-toggle="tooltip" data-placement="top" title="Optionally enter the link that gets you closer to the reviews."></i>
                                <input class="form-control" type="text" v-model="newChannelUrl" placeholder="(Optional)" />
                            </div>
                        </div>
                        <button type="button" class="btn btn-primary" :disabled="!canSubmit" @click="createConnection">Create</button>
                    </div>
                </td>
            </tr>
            <tr v-if="selectedChannel">
                <td colspan="3">
                    <div class="d-flex justify-content-between align-items-center">
                        <h5 class="header-case mb-0">Instructions</h5>
                        <a href="#" @click.prevent="copyIntoField" class="blue-link">Copy Into Field</a>
                    </div>
                    <p>Optional URL Format: {{ instructions[selectedChannel] }}</p>
                </td>
            </tr>
            <tr v-if="fillableChannelWatchers && fillableChannelWatchers.length">
                <td class="light-text text-uppercase pt-4">
                    Channel
                </td>
                <td class="light-text text-uppercase pt-4">
                    Name
                </td>
                <td class="light-text text-uppercase pt-4">
                    Url
                </td>
                <td class="pt-4">
                </td>
            </tr>
            <tr v-for="watcher in fillableChannelWatchers" :key="watcher.id">
                <td class="align-middle">
                    <img class="source-logo" :src="'/assets/img/reviews/' + watcher.provider + '.png'"/>
                </td>
                <td>
                    <strong class="mr-2">{{ watcher.source.providerName }}</strong>
                </td>
                <td>
                    <strong class="mr-2">{{ watcher.generatedUrl }}</strong>
                </td>
                <td>
                    <button class="btn btn-primary" type="button" @click="quickAdd(watcher)">Add connection</button>
                </td>
            </tr>
        </table>
    </div>
</template>
<script>
    import ClickHintConnectionName from './ClickHintConnectionName';
    export default {
        props: {
            team: Object
        },
        components: {
            ClickHintConnectionName
        },
        computed: {
            availableChannels() {
                return this.allChannels.filter(channel => {
                    return this.connected.filter(ch => {
                        return ch.source == channel;
                    }).length == 0;
                });
            },
            canSubmit() {
                return this.selectedChannel && this.newChannelSlug.length > 1 && !this.creating;
            },
            fillableChannelWatchers() {
                if (!this.channelWatchers) {
                    return [];
                }
                const regex = /\[[a-z0-9]+\]/gm;
                return this.channelWatchers.filter(watcher => {
                    const type = this.types[watcher.provider];
                    var connected = this.connected.find(element => element.source == watcher.provider);
                    connected = typeof connected !== 'undefined';

                    console.log(connected);
                    
                    if (this.connected !== null && connected) {
                        return false;
                    }
                    if (watcher.provider == 'trip_advisor') {
                        return true;
                    }
                    if (watcher.source[type] != null || watcher.provider == 'google') {
                        return watcher.source.providerName !== null;
                    }
                    return false;
                }).map(watcher => {
                    const newWatcher = JSON.parse(JSON.stringify(watcher));
                    newWatcher.generatedUrl = this.instructions[newWatcher.provider];
                    const type = this.types[newWatcher.provider];
                    const newId = newWatcher.source[type] ? newWatcher.source[type] : '';
                    if (newId == '') {
                        newWatcher.generatedUrl = null;
                    } else {
                        newWatcher.generatedUrl = newWatcher.generatedUrl.replace(regex, newId);
                    }
                    if (newWatcher.provider == 'trip_advisor' && newWatcher.source.providerName == null) {
                        newWatcher.source.providerName = this.mainName;
                    }
                    return newWatcher;
                });
            }
        },
        data() {
            return {
                allChannels: ['trip_advisor', 'booking_com', 'expedia', 'agoda', 'facebook_pages', 'ctrip', 'google', 'zoover', 'holiday_check'],
                connected: null,
                newChannelSlug: '',
                newChannelUrl: '',
                selectedChannel: '',
                loading: false,
                creating: false,
                startPath: '/',
                channelWatchers: [],
                mainName: '',
                types: {
                    trip_advisor: 'providerId',
                    booking_com: 'secondaryId',
                    expedia: 'providerId',
                    agoda: 'secondaryId',
                    facebook_pages: 'providerId',
                    ctrip: 'providerId',
                    google: 'secondaryId',
                    zoover: 'providerId',
                    holiday_check: 'providerId'
                },
                instructions: {
                    trip_advisor: 'https://www.tripadvisor.com/OwnerResponse-d[111]',
                    booking_com:'https://admin.booking.com/hotel/hoteladmin/extranet_ng/manage/reviews.html?hotel_id=[111]&lang=en&list=without_replies',
                    expedia: 'https://apps.expediapartnercentral.com/lodging/review/user_reviews.html?ch_nr=1&htid=[111]',
                    agoda: 'https://ycs.agoda.com/en-us/kipp/app/manage/review/[331453]',
                    facebook_pages: 'https://www.facebook.com/[111]/reviews/?ref=page_internal',
                    ctrip: 'https://ebooking.ctrip.com/ebkovsmisc/ebooking/commentList',
                    google: 'https://business.google.com/reviews/l/[111]',
                    zoover: 'https://portal.zoover.com/',
                    holiday_check: 'https://business.holidaycheck.com/hotel-admin/dashboard/'
                }
            }
        },
        watch: {
            team: {
                immediate: true,
                handler: function (newVal, oldVal) {
                    if (!newVal) {
                        return;
                    }
                    this.startPath = window.location.pathname.includes('extension') ?
                    `${window.location.origin + '/extension'}` : `${window.location.origin}`;
                    this.getConnections();
                    this.getChannelWatchers();
                    this.newChannelSlug = newVal.name;
                    this.mainName = newVal.name;
                }
            }
        },
        mounted() {
            this.startPath = window.location.pathname.includes('extension') ?
                `${window.location.origin + '/extension'}` : `${window.location.origin}`;
            Vue.nextTick(function() {
                $('[data-toggle="tooltip"]').tooltip()
            });
        },
        methods: {
            copyIntoField() {
                if (!this.selectedChannel) {
                    return;
                }
                this.newChannelUrl = this.instructions[this.selectedChannel];
            },
            quickAdd(watcher) {
                const postData = {
                    slug: watcher.source.providerName,
                    source: watcher.provider,
                    url: watcher.generatedUrl
                };
                this.sendNewConnectionRequest(postData);
            },
            removeConnection(connection) {
                this.loading = true;
                axios.delete(`${this.startPath}/connections/${this.team.id}/${connection.id}`)
                    .then(response => {
                        this.getConnections();
                    });
            },
            getConnections() {
                this.loading = true;
                axios.get(`${this.startPath}/connections/${this.team.id}`)
                    .then(response => {
                        this.loading = false;
                        this.connected = response.data;
                    });
            },
            getChannelWatchers() {
                axios.get(`/api/watchers/${this.team.id}`)
                    .then(response => {
                        this.channelWatchers = response.data;
                    });
            },
            sendNewConnectionRequest(postData) {
                this.creating = true;
                axios.post(`${this.startPath}/add-connection/${this.team.id}`, postData)
                    .then(response => {
                        this.creating = false;
                        this.getConnections();
                    });
            },
            createConnection() {
                const postData = {
                    slug: this.newChannelSlug,
                    source: this.selectedChannel,
                    url: this.newChannelUrl
                };
                this.sendNewConnectionRequest(postData);
            }
        }
    }
</script>

<style scoped>
    .source-logo {
        max-height: 35px;
    }
</style>